import { Member, Role } from '@tribeplatform/gql-client/types'

import { isMemberNotConfirmed, isUrlPointsWithinApp } from '../app.lib'

export const unconfirmedUsersRedirect = (
  member: Member,
  role: Role,
): boolean => {
  const { pathname } = window.location

  if (isMemberNotConfirmed(member, role) && isUrlPointsWithinApp(pathname)) {
    window.location.href = `/auth/verify?memberId=${member.id}`
    return true
  }
  return false
}
